import { Box, Button, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, Slide, Stack, Switch } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useSnackbar } from "notistack";
import React, { ReactElement } from "react";
import { ApiError } from "../../Api/ApiError";
import { regStudioTagData } from "../../Api/Store";
import { StudioData } from "../../Objects/StudioInterface";
import { StudioTag } from "../../Objects/StudioTagInterface";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />
})

export interface StudioTagEditDialogProps {
    studioTag?: StudioTag
    onClose: (isEdit: boolean) => void
}

const StudioTagEditDialog: React.FC<StudioTagEditDialogProps> = ({
    studioTag,
    onClose,
}) => {
    const { storeObjectState } = React.useContext(StoreObjectStore)
    let { enqueueSnackbar } = useSnackbar()

    const [open, setOpen] = React.useState<boolean>(false)
    const [stdIdList, setStdIdList] = React.useState<number[]>([])

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doSave = React.useCallback(() => {
        if (storeObjectState.storeData && storeObjectState.storeData?.str_id && studioTag && studioTag.stdtag_id) {
            regStudioTagData({
                str_id: storeObjectState.storeData?.str_id,
                stdtag_id: studioTag.stdtag_id,
                std_list: stdIdList
            }, {signal: abortController.signal}).then(() => {
                enqueueSnackbar("データを変更しました", { variant: "success" })
                onClose(true)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
    }, [abortController, enqueueSnackbar, studioTag, onClose, storeObjectState.storeData, stdIdList])

    React.useEffect(() => {
        setOpen(false)
        if (studioTag) {
            if (studioTag.std_list) {
                setStdIdList(studioTag.std_list)
            }
            setOpen(true)
        }
    }, [studioTag])

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={() => {
                onClose(false)
            }}
            fullWidth
        >
            <DialogTitle>スタジオタグデータを編集</DialogTitle>
            <DialogContent>
                {studioTag &&
                    <Box component="form" onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                        e.preventDefault()
                        doSave()
                    }} noValidate>
                        <Grid container>
                            {storeObjectState.studioList?.map((studioData: StudioData) => {
                                if (!studioData.std_id) {
                                    return null
                                }
                                return (
                                    <Grid item xs={12} sm={6} md={4}
                                        key={studioData.std_id}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={stdIdList?.includes(studioData.std_id)}
                                                    onChange={() => {
                                                        if (studioData.std_id) {
                                                            if (stdIdList.includes(studioData.std_id)) {
                                                                let list = stdIdList.filter(id => id !== studioData.std_id)
                                                                setStdIdList(list)
                                                            } else {
                                                                let list: number[] = [
                                                                    ...stdIdList,
                                                                    studioData.std_id
                                                                ]
                                                                setStdIdList(list)
                                                            }
                                                        }
                                                    }}
                                                />
                                            }
                                            label={studioData.std_name ? studioData.std_name : ""}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={2}
                        >
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    onClose(false)
                                }}
                            >キャンセル</Button>
                            <Button
                                variant="outlined"
                                type="submit"
                            >変更を実行</Button>
                        </Stack>
                    </Box>
                }
            </DialogContent>
        </Dialog>
    );
}

export default StudioTagEditDialog